import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../baseQuery';
import {
  GetOperationsDetailsPaymentsType,
  getOperationsDetailsTypes,
  TabOperationsResponseType,
} from './type';

export const operationsApi = createApi({
  reducerPath: 'operationsApi',
  tagTypes: ['Operations', 'Tags', 'OperationsDetails', 'OperationsDetailsPayments'],
  refetchOnReconnect: true,
  keepUnusedDataFor: 30,
  baseQuery: baseQueryWithReauth(),
  endpoints: (build) => ({
    getTabOperations: build.query<TabOperationsResponseType, { title: string }>({
      query: ({ title }) => ({
        url: `/operations/${title}`,
        method: 'GET',
      }),
      providesTags: () => ['Tags'],
    }),
    getOperationsDetails: build.query<getOperationsDetailsTypes, { name: string }>({
      query: ({ name }) => ({
        url: `/operations/${name}`,
        method: 'GET',
      }),
      providesTags: () => ['OperationsDetails'],
    }),

    getOperationsDetailsPayments: build.query<
      GetOperationsDetailsPaymentsType,
      { name: string }
    >({
      query: ({ name }) => ({
        url: `/operations/${name}`,
        method: 'GET',
      }),
      providesTags: () => ['OperationsDetails'],
    }),
  }),
});

export const {
  useGetTabOperationsQuery,
  useGetOperationsDetailsQuery,
  useGetOperationsDetailsPaymentsQuery,
} = operationsApi;
